// ** Icons Import
import { UserCheck, BarChart } from 'react-feather'

export default [
  {
    header: 'Kindergaten'
  },
  {
    id: 'aspek-perkembangan',
    title: 'Aspek Perkembang..',
    icon: <BarChart size={20} />,
    navLink: '/forms/aspek-perkembangan-anak'
  },
  {
    id: 'perkembangan-profil',
    title: 'Perkembangan Pro..',
    icon: <UserCheck size={20} />,
    navLink: '/forms/profil-pancasila-kindergaten'
  }
]
